import statistic from './statistic'

export default {
  settings: {
    hasOvertime: true,
    hasShootouts: true,
    hasDelayedEvents: true
  },
  actionTypes: {
    numberOfPlayersChangeEvents: [
      '20_SEC_EXCLUSION',
      '4_MIN_EXCLUSION',
      'PLAYER_ON_PITCH',
      'START_OVERTIME_PERIOD',
      'ADJUST_TEAMS',
      'TEAM_CORRECTION',
      'READY_TO_START'
    ]
  },
  modules: {
    info: [
      'timer',
      {
        type: 'players',
        props: {
          home: ingameData => ingameData.playersCount.home,
          away: ingameData => ingameData.playersCount.away
        }
      },
      {
        type: 'periods',
        props: {
          className: 'liveCardPeriods__slider_left'
        }
      }
    ],
    score: {
      component: 'score-component',
      score: ingameData => ingameData.score
    },
    fieldScheme: {
      component: 'match-center'
    },
    statistic,
    eventLog: true
  },
  storeScheme: {
    score: {
      home: 0,
      away: 0
    },
    playersCount: {
      home: 6,
      away: 6
    },
    shootoutsLog: {
      home: [],
      away: []
    },
    leftSideTeam: 1,
    getOvertimePeriodName: () => 'OT',
    shootoutStatisticTitle: 'trader.throws.shootout.score',
    shootoutPeriodName: 'SO'
  }
}
